import { jsx as _jsx } from "react/jsx-runtime";
import AgentsWorkspace from 'components/AgentsWorkspace';
export default function AgentsRoute() {
    return _jsx(AgentsWorkspace, {});
}
